import { Directive, HostBinding, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";

@Directive({ selector: "[dstRow],[dstCol]" })
export class SectionDirective {

    @Input() @BooleanAttribute() @HostBinding("class.u-flex-col") public dstCol: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-flex-row") public dstRow: boolean;

    @Input() @BooleanAttribute() @HostBinding("class.u-wrap-content") public wrapContent: boolean;

    @Input() @BooleanAttribute() @HostBinding("class.u-justify-content-space-around") public spaceAround: boolean;
    @Input() @BooleanAttribute() @HostBinding("class.u-justify-content-space-between") public spaceBetween: boolean;

    @Input() @BooleanAttribute()
    public set leftAlignContent(value: boolean) {
        this.alignItemsStart = !!this.dstCol || this.alignItemsStart;
        this.justifyContentStart = !!this.dstRow || this.justifyContentStart;
    }

    @Input() @BooleanAttribute()
    public set rightAlignContent(value: boolean) {
        this.alignItemsEnd = !!this.dstCol || this.alignItemsEnd;
        this.justifyContentEnd = !!this.dstRow || this.justifyContentEnd;
    }

    @Input() @BooleanAttribute()
    public set topAlignContent(value: boolean) {
        this.justifyContentStart = !!this.dstCol || this.justifyContentStart;
        this.alignItemsStart = !!this.dstRow || this.alignItemsStart;
    }

    @Input() @BooleanAttribute()
    public set bottomAlignContent(value: boolean) {
        this.justifyContentEnd = !!this.dstCol || this.justifyContentEnd;
        this.alignItemsEnd = !!this.dstRow || this.alignItemsEnd;
    }

    @Input() @BooleanAttribute()
    public set centerContentHorizontally(value: boolean) {
        this.alignItemsCenter = !!this.dstCol || this.alignItemsCenter;
        this.justifyContentCenter = !!this.dstRow || this.justifyContentCenter;
    }

    @Input() @BooleanAttribute()
    public set centerContentVertically(value: boolean) {
        this.justifyContentCenter = !!this.dstCol || this.justifyContentCenter;
        this.alignItemsCenter = !!this.dstRow || this.alignItemsCenter;
    }

    @HostBinding("class.u-justify-content-start") public justifyContentStart: boolean;
    @HostBinding("class.u-justify-content-end") public justifyContentEnd: boolean;
    @HostBinding("class.u-justify-content-center") public justifyContentCenter: boolean;

    @HostBinding("class.u-align-items-start") public alignItemsStart: boolean;
    @HostBinding("class.u-align-items-end") public alignItemsEnd: boolean;
    @HostBinding("class.u-align-items-center") public alignItemsCenter: boolean;
}

@Directive({
    selector: "[formSection],[readOnlySection]",
})
export class FormSectionDirective {
    @HostBinding("style.backgroundColor") public backgroundColor = "#F9FAFA";
    @HostBinding("style.padding") public padding = "10px";
    @HostBinding("style.margin-top") public marginTop = "5px";
    @HostBinding("style.margin-left") public marginLeft = "5px";
    @HostBinding("style.margin-right") public marginRight = "5px";
    @HostBinding("style.margin-bottom") public marginBottom = "0";

    @Input() @BooleanAttribute()
    public set isBottomSection(value: boolean) {
        this.marginBottom = value ? "5px" : "0";
    }
}
